import React, { Component } from "react";
import { RichUtils } from "draft-js";
import { Button, Icon } from "semantic-ui-react";

class InlineStyleButton extends Component {
  state = {
    active: false
  };
  toggleStyle = event => {
    event.preventDefault();
    this.props.setEditorState(
      RichUtils.toggleInlineStyle(this.props.getEditorState(), this.props.type)
    );
  };
  preventBubble = event => event.preventDefault();

  async componentDidUpdate() {
    const currentActiveStatus = this.isStyleActive();
    if (currentActiveStatus !== this.state.active) {
      this.setState({ active: currentActiveStatus });
    }
  }
  isStyleActive = () => {
    if (!this.props.getEditorState) {
      return false;
    }
    return this.props
      .getEditorState()
      .getCurrentInlineStyle()
      .has(this.props.type);
  };
  render() {
    return (
      <div onMouseDown={this.preventBubble}>
        <Button icon active={this.state.active} onClick={this.toggleStyle}>
          {this.props.children}
        </Button>
      </div>
    );
  }
}

export const ItalicButton = externalProps => (
  <InlineStyleButton type="ITALIC" {...externalProps}>
    <Icon name="italic" />
  </InlineStyleButton>
);

export const BoldButton = externalProps => (
  <InlineStyleButton type="BOLD" {...externalProps}>
    <Icon name="bold" />
  </InlineStyleButton>
);

export const UnderlineButton = externalProps => (
  <InlineStyleButton type="UNDERLINE" {...externalProps}>
    <Icon name="underline" />
  </InlineStyleButton>
);

export const LinkButton = externalProps => (
  <InlineStyleButton type="LINK" {...externalProps}>
    link
  </InlineStyleButton>
);



// WEBPACK FOOTER //
// ./src/pages/Contents/New/EditorButtons/InlineStyleButtons.js